import { render } from "./Docker.vue?vue&type=template&id=35ff7262&scoped=true&bindings={\"currentIndex\":\"props\",\"dockerList\":\"setup\"}"
import script from "./Docker.vue?vue&type=script&lang=js"
export * from "./Docker.vue?vue&type=script&lang=js"

import "./Docker.vue?vue&type=style&index=0&id=35ff7262&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-35ff7262"

export default script